import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import UserCardList from '../components/UserCardList.js';

// Hledaný výraz z cesty /user/:directSearch. window.location tady nestačí – po pushState
// níže ukazuje na /user, zatímco router location drží skutečnou cestu.
const getPathSearch = (pathname) => (typeof pathname.split('/')[2] != 'undefined' ? decodeURI(pathname.split('/')[2]) : '');

export default function User({usrInfo, timerCnt}) {
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [info, setInfo] = useState('');
	const [searchValue, setSearchValue] = useState(() => getPathSearch(location.pathname));
	const [locationKey, setLocationKey] = useState(location.key);
	const listRef = useRef(null);

	// Změna location: když se klikne na uživatele (např. v /member) a už jsme na /user,
	// komponenta se nepřemountuje – hledání se ale přepne a seznam se znovu načte.
	// Srovnáme to hned při renderu, ať se seznam nenačítá dvakrát (nejdřív se starou hodnotou).
	if (location.key !== locationKey) {
		setLocationKey(location.key);
		setSearchValue(getPathSearch(location.pathname));
	}

	useEffect(() => {
		if (getPathSearch(location.pathname) !== '') {
			window.history.pushState({}, document.title, '/user');
		}
	}, [location]);

	const handleLoadingChange = useCallback((isLoading) => {
		setLoading(isLoading);
	}, []);

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />

				<Search showSearch searchValue={searchValue} onChangeSearch={(e) => setSearchValue(e)}>
					<div className="icon_refresh_main mr_1" onClick={() => listRef.current?.refresh()}>
						<img className="icon_refresh fl_l cr_p mt_01" alt="" />
					</div>

					<span className="fl_l user-page__summary">
						<span className="user-page__summary-count">{info}</span>
						<img className="icon1 member user-page__summary-icon" alt="" />
					</span>
				</Search>

				<div className={`page user-page ${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<UserCardList ref={listRef} usrInfo={usrInfo} searchValue={searchValue} onChangeSearch={setSearchValue} reloadKey={locationKey} onLoadingChange={handleLoadingChange} onInfoChange={setInfo} />
				</div>
			</div>
		</>
	);
}
